cv.TeamBehavior = Marionette.Behavior.extend({
  // you can set default options
  // just like you can in your Backbone Models
  // they will be overriden if you pass in an option with the same key
  defaults: {
  },

  // behaviors have events that are bound to the views DOM
  events: {
    'click .cv-invite-team-members' : 'inviteMembers',
    'click .cv-manage-team' : 'manageTeam',
    'click .cv-join-team' : 'joinTeam'
  },

  initialize: function(){
    this.listenTo(vent, 'public:initialized', function(){
      this.team_id = 0;
      if($('#cv-team-id').length > 0){
        this.page_type = 'team';
        this.team_id = $('#cv-team-id').val();
      }
    }, this);

    this.listenTo(vent, 'team:refresh', this.updateTeam, this);
     
    console.log('TeamBehavior initialized');
  },

  inviteMembers: function(e){
    e.preventDefault();

    // Load the modal
    var view = new cv.TeamInviteView({
      team_id : $(e.currentTarget).data('team_id')
    });
    vent.trigger('modal:show', view);
  },

  joinTeam: function(e){
    e.preventDefault();

    if(cv.PRELOADED.logged_in == true){
      // Load the modal
      var view = new cv.ConfirmView({
        message : 'Are you sure you want to join this team?'
      });
      vent.trigger('modal:show', view);

      view.on('confirm', function(){
        $.ajax({
          url: cv.api_path + '/teams/' + this.team_id + "/add_member/" + cv.project.get('id'),
          dataType: "json",
          type: 'post',
          success: _.bind(function(data){
            vent.trigger('notif:success', 'You have joined this team.');

            top.location.reload();
          }, this),
          error: _.bind(function(data){
            vent.trigger('notif:error', $.parseJSON(data.responseText).data);
          }, this)
        });
      }, this);
    }else{
      top.location = '/signup?team_id=' + this.team_id;
    }
  },

  manageTeam: function(e){
    e.preventDefault();

    if(cv.PRELOADED.logged_in == true){
      cv.teamAdminRouter.navigate("dashboard", { trigger: true });
    }
  },

  updateTeam: function(){
    if(this.team_id != 0){
      $.ajax({
        url: cv.api_path + '/teams/' + this.team_id,
        dataType: "json",
        type: 'get',
        success: _.bind(function(response){
          // Update the profile photo
          var $replace_p = this.$('#details .profile-photo').clone();
    
          $replace_p.attr('data-src', cv.photo({
            photo_path : response.data.photo_path,
            photo_default : cv.campaign.get('default_team_photo'),
            url_only : true,
            transforms : {
              fit : 'crop'
            }
          }));
          
          this.$('#details .profile-photo').replaceWith($replace_p);
  
          setTimeout(_.bind(function(){
            imgix.fluid(this.$('#details .profile-photo').get(0), {
              updateOnResizeDown: false,
              pixelStep: 5,
              autoInsertCSSBestPractices: true
            });
          }, this), 50);

          // Update name
          this.$('#details .profile-name').text(response.data.name);
          document.title = response.data.name;

          // Update URL
          this.$('#details .profile-url a').attr('href', '//' + response.data.url);
          this.$('#details .profile-url a').html(response.data.url);

          // Update the description
          this.$('#main .post-entry').html(response.data.description);

          // Update any share URLs
          this.$('.cv-share').attr('data-url', response.data.url);

          // Update any donation URLs
          this.$('.cv-donate').attr('data-url', response.data.url);

          // Update the stats
          this.$('.cv-funds-needed').text(cv.formatMoney({
            show_sign : true,
            amount : response.data.funds_needed,
            currency_code : cv.campaign.get('currency_code'),
            decimal_places : 0
          }));
          this.$('.cv-funds-raised').text(cv.formatMoney({
            show_sign : true,
            amount : response.data.funds_raised,
            currency_code : cv.campaign.get('currency_code'),
            decimal_places : 0
          }));

          // Progress bar stuff
          var percent_progress = Math.round(response.data.funds_raised/response.data.funds_needed * 100);
          if(percent_progress > 100){
            percent_progress = 100;
          }
          this.$('#project-stats .progress-fill').css('width', percent_progress + '%');
          this.$('#project-stats .progress-tooltip').text(' ' + percent_progress + '%');
        }, this),
        error: _.bind(function(data){
        }, this)
      });
    }
  }
});